import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';
import { Flex } from '../Flex/Flex';
import { IconButton } from '../IconButton/IconButton';
import { applyVariations, colorSchemeCustomForeground, getPaletteColor } from '../utils/utils';
const variations = {
  border: css(["background-color:", ";color:", ";border-left:", " solid ", ";"], props => getPaletteColor(props.color, 'light')(props), getPaletteColor('text.base'), themeGet('borderRadii.sm'), props => getPaletteColor(props.color, 'base')(props)),
  fill: css([""])
};
export const LeftBorderFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Toaststyled__LeftBorderFlex",
  componentId: "sc-16n35yg-0"
})(["", ";", ""], applyVariations('Toast', variations), colorSchemeCustomForeground);
export const RoundIconButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "Toaststyled__RoundIconButton",
  componentId: "sc-16n35yg-1"
})(["&&&{background-color:", ";padding:", ";pointer-events:auto;&:hover{background-color:", ";}}"], getPaletteColor('background.lightest'), themeGet('space.1'), getPaletteColor('background.lightest'));